interface Constants {
    ApiUrl: string;
    MapboxPublicToken: string;
}

export const constants: Constants = {
    ApiUrl: 'https://estimmo-api.jmh.me',
    MapboxPublicToken: 'pk.eyJ1IjoiamFtaWVtaCIsImEiOiJja3ZwYnk0OWwxcWJ3MndrbGpwcHFnZnJ4In0.SBx3ccwkWhx0fnv1ElGUEA',
};
